import { brand } from './utils/brand';

document.documentElement.setAttribute('data-brand', brand);
